import React from 'react';
import { NavLink } from 'react-router-dom';
import { FiHome, FiUsers, FiPackage, FiDollarSign, FiShield, FiBarChart2, FiActivity, FiFileText, FiBriefcase } from 'react-icons/fi';

const sidebarConfig = {
  superadmin: {
    label: 'Super Admin',
    sections: [
      {
        title: 'Main',
        links: [
          { to: '/superadmin', icon: <FiHome />, label: 'Overview', end: true },
          { to: '/superadmin/companies', icon: <FiBriefcase />, label: 'B2B Companies' },
          { to: '/superadmin/packages', icon: <FiPackage />, label: 'Packages' },
          { to: '/superadmin/employees', icon: <FiUsers />, label: 'Employees' },
        ]
      },
      {
        title: 'Finance',
        links: [
          { to: '/superadmin/financial', icon: <FiDollarSign />, label: 'Financial Ledger' },
          { to: '/superadmin/insurance', icon: <FiShield />, label: 'Insurance' },
        ]
      },
      {
        title: 'Reports',
        links: [
          { to: '/superadmin/analytics', icon: <FiBarChart2 />, label: 'Analytics' },
          { to: '/superadmin/logs', icon: <FiActivity />, label: 'Audit Logs' },
        ]
      }
    ]
  },
  b2b: {
    label: 'B2B Client',
    sections: [
      {
        title: 'Main',
        links: [
          { to: '/b2b', icon: <FiHome />, label: 'Overview', end: true },
          { to: '/b2b/employees', icon: <FiUsers />, label: 'Employees' },
          { to: '/b2b/packages', icon: <FiPackage />, label: 'Packages' },
        ]
      },
      {
        title: 'Reports',
        links: [
          { to: '/b2b/analytics', icon: <FiBarChart2 />, label: 'Analytics' },
          { to: '/b2b/billing', icon: <FiFileText />, label: 'Billing & Invoices' },
        ]
      }
    ]
  }
};

function Sidebar({ dashboard }) {
  const config = sidebarConfig[dashboard];

  return (
    <aside className="sidebar">
      <div className="sidebar-logo">
        <h2>Mashwara</h2>
        <span>{config.label} Dashboard</span>
      </div>
      <nav className="sidebar-nav">
        {config.sections.map((section) => (
          <div key={section.title}>
            <div className="sidebar-section-title">{section.title}</div>
            {section.links.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.end}
                className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
              >
                {link.icon}
                {link.label}
              </NavLink>
            ))}
          </div>
        ))}
      </nav>
    </aside>
  );
}

export default Sidebar;
